
export default Object.freeze({
  getMousePosition: function (e) {
    return {
      x: e.clientX,
      y: e.clientY
    };
  }
});



// WEBPACK FOOTER //
// ./src/assets/javascripts/nesting/interface.js